import React, { useContext, useState, useEffect } from 'react'
import * as cam from "@mediapipe/camera_utils"
import { SelfieSegmentation } from '@mediapipe/selfie_segmentation';
import { useSnackbar } from 'notistack';

const VirtualBGContext = React.createContext();

export function useVirtualBG() {
    return useContext(VirtualBGContext)
}

export function VirtualBG({ children }) {

    const foregroundCanvasElement = document.createElement('canvas');
    const backgroundCanvasElement = document.createElement('canvas');
    const backgroundCanvasCtx = backgroundCanvasElement.getContext('2d');

    let outputCanvasCtx = null;
    let effectType = 'blur'; // blur | video | image
    let backgroundImage = null;
    let backgroundVideo = null;
    let foregroundType = 'normal'; // normal | presenter
    let presenterModeOffset = 0;

    let selfieSegmentation=null
    let inputVideo=null


    async function segmentBackground(inputVideoElement, outputCanvasElement, modelSelection = 0) {
        foregroundCanvasElement.width = backgroundCanvasElement.width = outputCanvasElement.width = inputVideoElement.videoWidth
        foregroundCanvasElement.height = backgroundCanvasElement.height = outputCanvasElement.height = inputVideoElement.videoHeight;
        outputCanvasCtx = outputCanvasElement.getContext('2d');

        console.log('Load selfieSegmentation model');
      
        selfieSegmentation = new SelfieSegmentation({
          locateFile: (file) => {
            return `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`;
          },
        });
        selfieSegmentation.setOptions({
          modelSelection: modelSelection,
        });
        selfieSegmentation.onResults((results) => {
          mergeForegroundBackground(
            foregroundCanvasElement,
            backgroundCanvasElement,
            results
          );
        });

        inputVideo= inputVideoElement

    }


    async function step() {
      console.log('STEP!!!')
      if (selfieSegmentation!==null){
        await selfieSegmentation.send({ image: inputVideo });
        requestAnimationFrame(step);
      }
    }

    async function startVirtualBG(){
      console.log('startVirtualBG')
      requestAnimationFrame(step);
      outputCanvasCtx = outputCanvasElement.getContext('2d');
    }

    async function stopVirtualBG(canvasElement){
      console.log('stopVirtualBG')
      selfieSegmentation=null
      const canvasCtx = canvasElement.getContext('2d');
      canvasCtx.save();
      canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
    }

    function mergeForegroundBackground(foregroundCanvasElement, backgroundCanvasElement, results) {
        makeCanvasLayer(results, foregroundCanvasElement, 'foreground');
        if (effectType === 'blur')
          makeCanvasLayer(results, backgroundCanvasElement, 'background');
        else if (effectType === 'image') {
          backgroundCanvasCtx.drawImage(
            backgroundImage,
            0,
            0,
            backgroundCanvasElement.width,
            backgroundCanvasElement.height
          );
        } else if (effectType === 'video') {
          backgroundCanvasCtx.drawImage(
            backgroundVideo,
            0,
            0,
            backgroundCanvasElement.width,
            backgroundCanvasElement.height
          );
        }
        outputCanvasCtx.drawImage(backgroundCanvasElement, 0, 0);
        if (foregroundType === 'presenter')
          outputCanvasCtx.drawImage(
            foregroundCanvasElement,
            foregroundCanvasElement.width * 0.5 - presenterModeOffset,
            foregroundCanvasElement.height * 0.5,
            foregroundCanvasElement.width * 0.5,
            foregroundCanvasElement.height * 0.5
          );
        else outputCanvasCtx.drawImage(foregroundCanvasElement, 0, 0);
    }

    function makeCanvasLayer(results, canvasElement, type) {
        const canvasCtx = canvasElement.getContext('2d');
      
        canvasCtx.save();
      
        canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
        canvasCtx.drawImage(
          results.segmentationMask,
          0,
          0,
          canvasElement.width,
          canvasElement.height
        );
        if (type === 'foreground') {
          canvasCtx.globalCompositeOperation = 'source-in';
        }
      
        canvasCtx.drawImage(
          results.image,
          0,
          0,
          canvasElement.width,
          canvasElement.height
        );
      
        canvasCtx.restore();
    }

    function applyBlur(blurIntensity = 7) {
        effectType = 'blur';
        foregroundType = 'normal';
        backgroundCanvasCtx.filter = `blur(${blurIntensity}px)`;
    }

    function applyImageBackground(image) {
        backgroundImage = image;
        effectType = 'image';
        foregroundType = 'normal';
    }

    function changeForegroundType(type, offset = 0) {
        foregroundType = type;
        presenterModeOffset = offset;
    }


    const value = {
        segmentBackground, applyBlur, applyImageBackground, changeForegroundType, startVirtualBG, stopVirtualBG
    }


    return (
        <VirtualBGContext.Provider value={value}>
            {children}
        </VirtualBGContext.Provider>
    )

}